module.exports = "<fuse-main></fuse-main>\n"


//////////////////
// WEBPACK FOOTER
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main